// client/src/pages/adminpages/AdvertiserInfoPage.js
import React, { useState } from 'react';
import AdminLayout from '../../components/admin/layout/AdminLayout';
import AdvertiserInfoList from '../../components/admin/advertiser/AdvertiserInfoList';
import AdvertiserInfoEditModal from '../../components/admin/advertiser/AdvertiserInfoEditModal';
import AdvertiserPointAddModal from '../../components/admin/advertiser/AdvertiserPointAddModal';
import AdvertiserPointDeductModal from '../../components/admin/advertiser/AdvertiserPointDeductModal';
import AdvertiserBizInfoEditModal from '../../components/admin/advertiser/AdvertiserBizInfoEditModal';
import AdvertiserPointHistoryModal from '../../components/admin/advertiser/AdvertiserPointHistoryModal';
import '../../styles/admin/AdminSummary.css';

const API_URL = process.env.REACT_APP_API_URL || '';

function AdvertiserInfoPage() {
  const [selected, setSelected] = useState(null);
  const [detail, setDetail] = useState(null);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState('');
  const [searchInput, setSearchInput] = useState('');
  const [showEditModal, setShowEditModal] = useState(false);
  const [showPointAddModal, setShowPointAddModal] = useState(false);
  const [showPointDeductModal, setShowPointDeductModal] = useState(false);
  const [showBizEditModal, setShowBizEditModal] = useState(false);
  const [showPointHistoryModal, setShowPointHistoryModal] = useState(false);

  // 선택 시 상세 정보 조회
  const handleSelect = async (item) => {
    setSelected(item);
    setLoading(true);
    try {
      const res = await fetch(`${API_URL}/api/admin/advertiser/info/${item.userId}`, {
        credentials: 'include'
      });
      const data = await res.json();
      if (data.ok) {
        setDetail(data.user);
      } else {
        setDetail(null);
      }
    } catch (err) {
      console.error('handleSelect error:', err);
      setDetail(null);
    }
    setLoading(false);
  };

  const handleSearch = () => {
    setSearch(searchInput);
  };

  const handleSearchKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  const getTypeLabel = (type) => {
    const labels = {
      'corporate': '법인 회사',
      'sole': '개인사업자',
      'agency': '광고사',
      'freelancer': '프리랜서'
    };
    return labels[type] || type;
  };

  const getApprovedLabel = (approved) => {
    return approved ? '승인' : '미승인';
  };

  return (
    <AdminLayout title="광고주 정보관리">
      <div className="admin-grid">
        {/* 왼쪽: 목록 */}
        <div className="admin-section" style={{ height: 'calc(100vh - 120px)' }}>
          {/* 검색 */}
          <div className="admin-list__search">
            <div className="admin-list__search-grid">
              <input
                className="admin-list__search-input admin-list__search-input--full"
                type="text"
                placeholder="광고주 ID 또는 이름 검색"
                value={searchInput}
                onChange={(e) => setSearchInput(e.target.value)}
                onKeyPress={handleSearchKeyPress}
              />
            </div>
            <div className="admin-list__search-actions">
              <button
                className="admin-list__search-button admin-list__search-button--primary"
                onClick={handleSearch}
              >
                검색
              </button>
            </div>
          </div>

          <AdvertiserInfoList
            onSelect={handleSelect}
            selectedId={selected?.userId}
            search={search}
          />
        </div>

        {/* 오른쪽: 상세 정보 */}
        <div className="admin-section admin-section--wide" style={{ height: 'calc(100vh - 120px)', overflowY: 'auto' }}>
          <h3 className="admin-summary__title">광고주 상세 정보</h3>
          {!selected ? (
            <div className="admin-summary__empty">
              왼쪽 목록에서 광고주를 선택하세요.
            </div>
          ) : loading ? (
            <div className="admin-summary__loading">불러오는 중...</div>
          ) : detail ? (
            <div>
              {/* 1. 기본 정보 */}
              <section style={{ marginBottom: 32 }}>
                <div style={{ 
                  display: 'flex', 
                  justifyContent: 'space-between', 
                  alignItems: 'center',
                  marginBottom: 16, 
                  paddingBottom: 8, 
                  borderBottom: '2px solid var(--admin-color-primary)'
                }}>
                  <h4 style={{ margin: 0, color: 'var(--admin-color-primary)' }}>
                    기본 정보
                  </h4>
                  <button
                    className="admin-section__button"
                    onClick={() => setShowEditModal(true)}
                    style={{ padding: '6px 14px', fontSize: 13 }}
                  >
                    수정
                  </button>
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: '150px 1fr', gap: '12px 20px', fontSize: '14px' }}>
                  <div style={{ fontWeight: 600, color: 'var(--admin-text-sub)' }}>광고주 ID</div>
                  <div style={{ color: 'var(--admin-text-main)' }}>{detail.userId}</div>
                  
                  <div style={{ fontWeight: 600, color: 'var(--admin-text-sub)' }}>회원 유형</div>
                  <div>
                    <span className="admin-list__item-badge admin-list__item-badge--primary">
                      {getTypeLabel(detail.type)}
                    </span>
                  </div>
                  
                  <div style={{ fontWeight: 600, color: 'var(--admin-text-sub)' }}>이름</div>
                  <div style={{ color: 'var(--admin-text-main)' }}>{detail.userName}</div>
                  
                  <div style={{ fontWeight: 600, color: 'var(--admin-text-sub)' }}>연락처</div>
                  <div style={{ color: 'var(--admin-text-main)' }}>{detail.callNumber}</div>
                  
                  <div style={{ fontWeight: 600, color: 'var(--admin-text-sub)' }}>이메일</div>
                  <div style={{ color: 'var(--admin-text-main)' }}>{detail.email}</div>
                  
                  <div style={{ fontWeight: 600, color: 'var(--admin-text-sub)' }}>가입일</div>
                  <div style={{ color: 'var(--admin-text-main)' }}>{new Date(detail.registeredAt).toLocaleString('ko-KR')}</div>
                  
                  <div style={{ fontWeight: 600, color: 'var(--admin-text-sub)' }}>승인 상태</div>
                  <div>
                    <span className={`admin-list__item-badge ${detail.approved ? 'admin-list__item-badge--success' : 'admin-list__item-badge--danger'}`}>
                      {getApprovedLabel(detail.approved)}
                    </span>
                  </div>
                  
                  <div style={{ fontWeight: 600, color: 'var(--admin-text-sub)' }}>마케팅 수신 동의</div>
                  <div style={{ color: 'var(--admin-text-main)' }}>{detail.marketingOption ? '예' : '아니오'}</div>
                </div>
              </section>

              {/* 2. 유형별 상세 정보 */}
              <section style={{ marginBottom: 32 }}>
                <h4 style={{ 
                  marginBottom: 16, 
                  paddingBottom: 8, 
                  borderBottom: '2px solid var(--admin-color-primary)',
                  color: 'var(--admin-color-primary)',
                  marginTop: 0
                }}>
                  유형별 상세 정보
                </h4>
                <div style={{ display: 'grid', gridTemplateColumns: '150px 1fr', gap: '12px 20px', fontSize: '14px' }}>
                  {(detail.type === 'corporate' || detail.type === 'agency') && (
                    <>
                      <div style={{ fontWeight: 600, color: 'var(--admin-text-sub)' }}>회사명</div>
                      <div style={{ color: 'var(--admin-text-main)' }}>{detail.companyName || '-'}</div>
                      
                      <div style={{ fontWeight: 600, color: 'var(--admin-text-sub)' }}>직급</div>
                      <div style={{ color: 'var(--admin-text-main)' }}>{detail.position || '-'}</div>
                    </>
                  )}
                  
                  {detail.type === 'sole' && (
                    <>
                      <div style={{ fontWeight: 600, color: 'var(--admin-text-sub)' }}>상호</div>
                      <div style={{ color: 'var(--admin-text-main)' }}>{detail.businessName || '-'}</div>
                    </>
                  )}
                  
                  {(detail.type === 'corporate' || detail.type === 'sole') && (
                    <>
                      <div style={{ fontWeight: 600, color: 'var(--admin-text-sub)' }}>홍보할 제품 종류</div>
                      <div style={{ color: 'var(--admin-text-main)' }}>
                        {detail.productCategories && detail.productCategories.length > 0
                          ? detail.productCategories.join(', ')
                          : '-'}
                      </div>
                    </>
                  )}
                  
                  {detail.type === 'freelancer' && (
                    <>
                      <div style={{ fontWeight: 600, color: 'var(--admin-text-sub)' }}>협업 희망 여부</div>
                      <div style={{ color: 'var(--admin-text-main)' }}>{detail.cooperationWish ? '예' : '아니오'}</div>
                    </>
                  )}
                </div>
              </section>

              {/* 3. 포인트 정보 */}
              <section style={{ marginBottom: 32 }}>
                <div style={{ 
                  display: 'flex', 
                  justifyContent: 'space-between', 
                  alignItems: 'center',
                  marginBottom: 16, 
                  paddingBottom: 8, 
                  borderBottom: '2px solid var(--admin-color-primary)'
                }}>
                  <h4 style={{ margin: 0, color: 'var(--admin-color-primary)' }}>
                    포인트 정보
                  </h4>
                  <div className="admin-section__actions" style={{ margin: 0 }}>
                    <button
                      className="admin-section__button"
                      onClick={() => setShowPointAddModal(true)}
                      style={{ padding: '6px 14px', fontSize: 13, backgroundColor: 'var(--admin-color-success)', borderColor: 'var(--admin-color-success)' }}
                    >
                      포인트 지급
                    </button>
                    <button
                      className="admin-section__button"
                      onClick={() => setShowPointDeductModal(true)}
                      style={{ padding: '6px 14px', fontSize: 13, backgroundColor: 'var(--admin-color-danger)', borderColor: 'var(--admin-color-danger)' }}
                    >
                      포인트 차감
                    </button>
                    <button
                      className="admin-section__button"
                      onClick={() => setShowPointHistoryModal(true)}
                      style={{ padding: '6px 14px', fontSize: 13 }}
                    >
                      포인트 이력 조회
                    </button>
                  </div>
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: '200px 1fr', gap: '12px 20px', fontSize: '14px' }}>
                  <div style={{ fontWeight: 600, color: 'var(--admin-text-sub)' }}>보유 포인트</div>
                  <div style={{ fontSize: 18, fontWeight: 600, color: 'var(--admin-color-primary)' }}>
                    {(detail.points || 0).toLocaleString()}pt
                  </div>
                  
                  <div style={{ fontWeight: 600, color: 'var(--admin-text-sub)' }}>환불 처리 중</div>
                  <div style={{ fontSize: 16, color: 'var(--admin-color-warning)' }}>
                    {(detail.pendingRefundPoints || 0).toLocaleString()}pt
                  </div>
                  
                  <div style={{ fontWeight: 600, color: 'var(--admin-text-sub)' }}>진행 중 프로젝트 결제 금액</div>
                  <div style={{ fontSize: 16, color: '#9c27b0' }}>
                    {(detail.ongoingPaymentAmount || 0).toLocaleString()}pt
                  </div>
                </div>
              </section>

              {/* 4. 사업자 정보 */}
              <section style={{ marginBottom: 32 }}>
                <h4 style={{ 
                  marginBottom: 16, 
                  paddingBottom: 8, 
                  borderBottom: '2px solid var(--admin-color-primary)',
                  color: 'var(--admin-color-primary)',
                  marginTop: 0
                }}>
                  사업자 정보
                </h4>
                <div style={{ display: 'grid', gridTemplateColumns: '150px 1fr', gap: '12px 20px', fontSize: '14px' }}>
                  <div style={{ fontWeight: 600, color: 'var(--admin-text-sub)' }}>사업자 등록번호</div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <span style={{ color: 'var(--admin-text-main)' }}>{detail.bizRegNo || '미등록'}</span>
                    <button
                      className="admin-section__button"
                      onClick={() => setShowBizEditModal(true)}
                      style={{ padding: '4px 10px', fontSize: 12 }}
                    >
                      수정
                    </button>
                  </div>
                  
                  <div style={{ fontWeight: 600, color: 'var(--admin-text-sub)' }}>사업자 등록증</div>
                  <div>
                    {detail.bizCertImg && detail.bizCertImg.length > 0 ? (
                      <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                        {detail.bizCertImg.map((img, index) => (
                          <div 
                            key={index}
                            style={{
                              padding: 12,
                              background: 'var(--admin-bg-body)',
                              borderRadius: 8,
                              border: '1px solid var(--admin-border-color)'
                            }}
                          >
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                              <div>
                                <div style={{ fontSize: 14, fontWeight: 600, marginBottom: 4, color: 'var(--admin-text-main)' }}>
                                  {img.filename || `파일 ${index + 1}`}
                                </div>
                                <div style={{ fontSize: 12, color: 'var(--admin-text-sub)' }}>
                                  {img.uploadedAt ? new Date(img.uploadedAt).toLocaleDateString('ko-KR') : '-'}
                                  {' · '}
                                  상태: <span className={`admin-list__item-badge ${
                                    img.status === 'approved' ? 'admin-list__item-badge--success' : 
                                    img.status === 'rejected' ? 'admin-list__item-badge--danger' : 'admin-list__item-badge--warning'
                                  }`}>
                                    {img.status === 'approved' ? '승인' : 
                                     img.status === 'rejected' ? '거절' : '대기'}
                                  </span>
                                </div>
                              </div>
                              <a
                                href={img.url}
                                download
                                target="_blank"
                                rel="noopener noreferrer"
                                className="admin-section__button"
                                style={{
                                  padding: '6px 12px',
                                  fontSize: 12,
                                  textDecoration: 'none',
                                  display: 'inline-block'
                                }}
                              >
                                다운로드
                              </a>
                            </div>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div style={{ color: 'var(--admin-text-muted)' }}>등록된 사업자 등록증이 없습니다.</div>
                    )}
                  </div>
                </div>
              </section>

              {/* 5. 프로젝트 통계 */}
              <section>
                <h4 style={{ 
                  marginBottom: 16, 
                  paddingBottom: 8, 
                  borderBottom: '2px solid var(--admin-color-primary)',
                  color: 'var(--admin-color-primary)',
                  marginTop: 0
                }}>
                  프로젝트 통계
                </h4>
                
                {detail.projectStats ? (
                  <div>
                    {/* 기본 통계 */}
                    <div style={{ display: 'grid', gridTemplateColumns: '180px 1fr', gap: '12px 20px', marginBottom: 24, fontSize: '14px' }}>
                      <div style={{ fontWeight: 600, color: 'var(--admin-text-sub)' }}>총 프로젝트 수</div>
                      <div style={{ fontSize: 18, fontWeight: 600, color: 'var(--admin-color-primary)' }}>
                        {detail.projectStats.totalProjects}개
                      </div>
                      
                      <div style={{ fontWeight: 600, color: 'var(--admin-text-sub)' }}>총 사용 금액 (완료)</div>
                      <div style={{ fontSize: 18, fontWeight: 600, color: 'var(--admin-color-success)' }}>
                        {(detail.projectStats.totalUsedAmount || 0).toLocaleString()}원
                      </div>
                    </div>

                    {/* 진행 중인 프로젝트 */}
                    <div style={{ marginBottom: 24 }}>
                      <div style={{ 
                        fontWeight: 600, 
                        color: 'var(--admin-text-sub)', 
                        marginBottom: 12,
                        fontSize: 15
                      }}>
                        진행 중인 프로젝트 ({detail.projectStats.ongoingProjects.length}개)
                      </div>
                      {detail.projectStats.ongoingProjects.length > 0 ? (
                        <div style={{ 
                          padding: 16, 
                          background: '#fff3e0', 
                          borderRadius: 8,
                          border: '1px solid var(--admin-color-warning)'
                        }}>
                          <ul style={{ margin: 0, paddingLeft: 20 }}>
                            {detail.projectStats.ongoingProjects.map((project, index) => (
                              <li key={index} style={{ marginBottom: 8, fontSize: 14, color: 'var(--admin-text-main)' }}>
                                <strong>{project.projectNumber}</strong> - {project.title}
                              </li>
                            ))}
                          </ul>
                        </div>
                      ) : (
                        <div style={{ padding: 16, background: 'var(--admin-bg-body)', borderRadius: 8, color: 'var(--admin-text-muted)' }}>
                          진행 중인 프로젝트가 없습니다.
                        </div>
                      )}
                    </div>

                    {/* 완료된 프로젝트 */}
                    <div>
                      <div style={{ 
                        fontWeight: 600, 
                        color: 'var(--admin-text-sub)', 
                        marginBottom: 12,
                        fontSize: 15
                      }}>
                        완료된 프로젝트 ({detail.projectStats.completedProjects.length}개)
                      </div>
                      {detail.projectStats.completedProjects.length > 0 ? (
                        <div style={{ 
                          padding: 16, 
                          background: '#e8f5e9', 
                          borderRadius: 8,
                          border: '1px solid var(--admin-color-success)'
                        }}>
                          <ul style={{ margin: 0, paddingLeft: 20 }}>
                            {detail.projectStats.completedProjects.map((project, index) => (
                              <li key={index} style={{ marginBottom: 8, fontSize: 14, color: 'var(--admin-text-main)' }}>
                                <strong>{project.projectNumber}</strong> - {project.title}
                              </li>
                            ))}
                          </ul>
                        </div>
                      ) : (
                        <div style={{ padding: 16, background: 'var(--admin-bg-body)', borderRadius: 8, color: 'var(--admin-text-muted)' }}>
                          완료된 프로젝트가 없습니다.
                        </div>
                      )}
                    </div>
                  </div>
                ) : (
                  <div style={{ color: 'var(--admin-text-muted)' }}>프로젝트 통계 정보를 불러올 수 없습니다.</div>
                )}
              </section>
            </div>
          ) : null}
        </div>
      </div>

      {/* 기본 정보 수정 모달 */}
      <AdvertiserInfoEditModal
        open={showEditModal}
        onClose={() => setShowEditModal(false)}
        advertiser={detail}
        onSuccess={() => {
          // 수정 성공 시 상세 정보 다시 불러오기
          if (selected) {
            handleSelect(selected);
          }
        }}
      />

      {/* 포인트 지급 모달 */}
      <AdvertiserPointAddModal
        open={showPointAddModal}
        onClose={() => setShowPointAddModal(false)}
        advertiser={detail}
        onSuccess={() => {
          // 지급 성공 시 상세 정보 다시 불러오기
          if (selected) {
            handleSelect(selected);
          }
        }}
      />

      {/* 포인트 차감 모달 */}
      <AdvertiserPointDeductModal
        open={showPointDeductModal}
        onClose={() => setShowPointDeductModal(false)}
        advertiser={detail}
        onSuccess={() => {
          // 차감 성공 시 상세 정보 다시 불러오기
          if (selected) {
            handleSelect(selected);
          }
        }}
      />

      {/* 사업자 정보 수정 모달 */}
      <AdvertiserBizInfoEditModal
        open={showBizEditModal}
        onClose={() => setShowBizEditModal(false)}
        advertiser={detail}
        onSuccess={() => {
          // 수정 성공 시 상세 정보 다시 불러오기
          if (selected) {
            handleSelect(selected);
          }
        }}
      />

      {/* 포인트 이력 조회 모달 */}
      <AdvertiserPointHistoryModal
        open={showPointHistoryModal}
        onClose={() => setShowPointHistoryModal(false)}
        advertiser={detail}
      />
    </AdminLayout>
  );
}

export default AdvertiserInfoPage;
